<div *ngFor="let alert of alerts" class="{{cssClass(alert)}}">
  <div class="alert-content">
    <mat-icon svgIcon="{{alert.icon}}" aria-hidden="false" aria-label="Ícone de alerta"></mat-icon>
    <div>
      <span>{{alert.message}}</span>
      <p *ngIf="alert.supportingText">{{alert.supportingText}}</p>
      <a *ngIf="alert.openTicket" rel="noopener" class="button-link" target="_blank" href="https://empresas.unico.io/hc/pt-br">
        {{alert.openTicket}}
        <mat-icon
          svgIcon="{{alert.openTicketIcon}}"
          aria-hidden="false"
          aria-label="Ícone de seta"
        ></mat-icon>
      </a>
    </div>
  </div>
  <a class="close" (click)="removeAlert(alert)" aria-label="Ícone de fechar alerta">&times;</a>
</div>
